import React, { useEffect, useRef, useState } from 'react';
import AlternativeSelect from 'components/AlternativeSelect/AlternativeSelect';

export const AlternativeSelectWrapper = (props: any) => {
	const targetRef = useRef<HTMLDivElement>(null);
	const [showAlternatiiveSelectChild, setShowAlternatiiveSelectChild] = useState(false);

	const handleOutsideClick = () => {
		setShowAlternatiiveSelectChild(false);
	};

	const handleClick = () => {
		setShowAlternatiiveSelectChild(true);
	};

	// This useeffect is to set event handler for the alternative select, so that when ckisked outside the dropdown , the dropdown closes
	useEffect(() => {
		function handleClickOutside(event: any) {
			if (targetRef.current) {
				// this is a check to prevent the dropdown from closing when clicing inside the calander,as react is replacing the elements of the calander when we click on any th with class rdtSwitch, hence defeating the purpose of our checks.
				if ([...event.target.classList].some((className) => className.startsWith('rdt'))) {
					return;
				}
				// hide the dropdown when not clicking inside the current target
				if (!targetRef.current?.contains(event.target)) {
					handleOutsideClick();
				}
			}
		}
		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [handleClick, handleOutsideClick]);

	return (
		<div ref={targetRef}>
			<AlternativeSelect
				{...props}
				hideOnBlur={false}
				renderChildren={showAlternatiiveSelectChild}
				setRenderChildren={setShowAlternatiiveSelectChild}
				dropdownIconClick={(hide: boolean) => (hide ? handleClick() : handleOutsideClick())}
			/>
		</div>
	);
};
